
import { Component, Mixins, Prop } from "vue-property-decorator";
import { formMixin, formTextMixin, formValidationMixin } from "../mixins";

@Component({
  inheritAttrs: false
})
export default class Input extends Mixins(formMixin, formTextMixin, formValidationMixin) {
  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ default: false })
  highlight: boolean;

  @Prop({ default: true })
  showClear: boolean;

  @Prop({ default: 0 })
  warningLevel: number;

  @Prop({default: false})
  isZip: boolean

  @Prop({default: false})
  enterOnSubmit: boolean

  focus() {
    this.$nextTick(() => this.$refs.input.focus());
  }

  getWarningClass() {
    if(this.warningLevel > 0)
    {
      return "input-warning-" + this.warningLevel.toString();
    }
    return null;
  }

  enterPressed() {
    if(this.enterOnSubmit === true){
      this.$emit('enterPressed', this.localValue);
    }
  }
}
